import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#c58706',
        success: '#00ab55',
        warning: '#FF3C5F',

        // redesign
        uiPrimary: '#F5F6FA',
        uiSecondary1: '#FFFFFF',
        uiSecondary2: '#222F3E',
        uiSecondary3: '#1A232F',
        textPrimary: '#2A3038',
        textSecondary1: '#6D737D',
        textSecondary2: '#90A0B7',
        textTertiary: '#FFFFFF',
        uiInteractive: '#5BC1C1',
        uiInteractiveHover: '#1B9998',
        iconButton1: '#6D737D',
        iconButtonInteractionActive1: '#505760',
        iconButton2: '#5BC1C1',
        iconButtonInteractionActive2: '#1B9998',
        functionalError: '#D10006',
        functionalWarning: '#F88422',
        functionalSuccess: '#2E9422',
        uiLine: '#E2E6EC',
        iconInfo: '#505760',
        uiSecondary01: '#E9ECEF',
        uiSecondary02: '#DEE2E6',
        uiLine01: '#C8C8C8',
        uiPrimary01: '#FFFFFF',
        uiInteractive01: '#007BFF',
        textPrimary01: '#212529',
        uiPrimaryHover: '#EDF1F7',
        textSecondary: '#495057',
        iconDisabled: '#AEB0B3',
        uilabel1: '#334d6e',
        uilabel2: '#c58706',
      },
    },
  },
});
